import * as angular from "angular";
import * as _ from "lodash";
import template from "./openReleaseNotes.tpl.html";

let requires = [];

export function openReleaseNotes(
  $modal: mm.foundation.modal,
  data: any
): mm.foundation.modalInstance {
  return $modal.open({
    template: template,
    controller: "OpenReleaseNotesCtrl as vm",
    resolve: {
      releaseData: () => data
    }
  });
}

export interface IOpenReleaseNotesCtrl {
  openRleaseNotes(): void;
  close(): void;
  getDescriptionList();
  title: string;
  description: string;
  notification: any;
}
function openReleaseNotesCtrl(
  $modalInstance: mm.foundation.modalInstance,
  releaseData: any
) {
  let vm = this as IOpenReleaseNotesCtrl;
  vm.notification = releaseData;
  vm.title = releaseData.title;
  vm.description = releaseData.description;

  vm.openRleaseNotes = () => {
    //TODO: api-call
  };

  vm.close = () => {
    $modalInstance.close();
  };

  vm.getDescriptionList = function () {
    if (!vm.description) return [];
  
    // Split based on number-dot-space pattern (e.g., "1. ", "2. ", etc.)
    return vm.description
      .split(/\d+\.\s/)
      .filter(function (item) {
        return item.trim() !== '';
      });
  };
}

export default angular
  .module("aps.controller.openReleaseNotes", requires)
  .controller("OpenReleaseNotesCtrl", openReleaseNotesCtrl).name;



// WEBPACK FOOTER //
// ./src/app/layout/header/openReleaseNotes.controller.ts